import {graphql} from 'gatsby'
import React from 'react'

import type {
    GetStartedSliceFragment,
    GetStartedFragment,
    PartnerTemplateGetStartedFragment,
    CustomerCaseGetStartedFragment,
} from '@/graphql-types'
import SignupBannerSection from '@/sections/signup-banner'
import {DocTypesEnum} from '@/utils/link-resolver'
import {LeadInterestLevel} from '@helios/shared/types/marketing-campaigns'
import getEnvironmentFormId from '@helios/shared/utils/get-environment-field'

type Props = {
    slice:
        | GetStartedSliceFragment
        | GetStartedFragment
        | PartnerTemplateGetStartedFragment
        | CustomerCaseGetStartedFragment
    dataTestId?: string
}

export const GetStartedSlice = React.forwardRef<HTMLDivElement, Props>(
    ({slice, dataTestId}, ref) => {
        const data = slice.primary
        const predefined = data.predefined_signup_banner.document
        const redirectsToParterBigformPage =
            predefined?.data.redirect_link?.type === DocTypesEnum.PARTNER_BIGFORM_PAGE
        const formId = getEnvironmentFormId(
            predefined?.data.hubspot_form_id_production || data.hubspot_form_id_production,
            predefined?.data.hubspot_form_id_staging || data.hubspot_form_id_staging
        )

        return (
            <SignupBannerSection
                ref={ref}
                image={predefined?.data.image || data.image}
                title={predefined?.data.title || data.title}
                errorText={predefined?.data.email_input_error_text || data.error_message}
                placeholder={predefined?.data.email_input_placeholder || data.input_placeholder}
                submitText={predefined?.data.submit_text || data.button_label}
                subtitle={predefined?.data.subtitle || data.form_subtitle}
                ariaLabel={predefined?.data.aria_label || data.aria_label}
                dataTestId={dataTestId}
                formId={formId}
                signupOptions={{
                    form: predefined?.data.form_name,
                    redirectPath:
                        predefined?.data.redirect_link?.uid &&
                        `/${predefined.data.redirect_link.uid}`,
                    leadInterestLevel: redirectsToParterBigformPage
                        ? LeadInterestLevel.Interested
                        : '',
                }}
                color="pink"
            />
        )
    }
)

export const getStartedSliceFragment = graphql`
    fragment GetStartedSlice on PrismicSlicePageDataBodyGetStarted {
        __typename
        primary {
            title
            error_message
            button_label
            input_placeholder
            form_subtitle
            aria_label
            hubspot_form_id_staging
            hubspot_form_id_production
            image {
                alt
                copyright
                url
                dimensions {
                    width
                    height
                }
            }
            predefined_signup_banner {
                document {
                    ...SignupBanner
                }
            }
        }
    }
`
